<div *ngIf="hasIcon; else noIconTemplate" [formGroup]="formGroup" class="tw-relative">
  <button type="button" [attr.aria-label]="iconAriaLabel || null" class="{{ iconClass }} tw-absolute tw-right-3 tw-top-1/3 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-gray-500" (click)="handleClick()"></button>
  <input [formControlName]="keyControl" [type]="type" [attr.aria-label]="ariaLabel || null" [attr.autocomplete]="autocomplete || null" class="focus-visible:tw-border-2 focus-visible:tw-outline-0 focus-visible:tw-border-border-main tw-text-main-text tw-rounded-xl tw-py-2 tw-pl-5 tw-pr-8 tw-border tw-border-border-light-gray tw-w-full focus:tw-ring-0 {{className}}" [placeholder]="placeholder"/>
</div>

<ng-template #noIconTemplate>
  <div [formGroup]="formGroup">
    <input
      [formControlName]="keyControl"
      [type]="type"
      [attr.aria-label]="ariaLabel || null"
      [attr.autocomplete]="autocomplete || null"
      [attr.min]="minDate ? minDate : null"
      [OnlyNumber]="onlyNumber"
      class="focus-visible:tw-border-2 focus-visible:tw-outline-0 focus-visible:tw-border-border-main tw-text-main-text tw-rounded-xl tw-py-2 tw-px-5 tw-border tw-border-border-light-gray tw-w-full focus:tw-ring-0 {{className}}"
      [placeholder]="placeholder"
      [attr.maxLength]="maxLength ? maxLength : null"
    />
  </div>
</ng-template>
